module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars-b0c3eec4a18e4447a51d55bc8bc42d6b.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars.png
// module id = fyLg
// module chunks = 9 11 12